import React, { forwardRef } from 'react';

import type { EmotionsNullableParameter } from '@vlabs/api/luna-api/model';
import { EMOTION_OPTIONS } from '@vlabs/api-bindings/src/constants';

import { OptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFilters } from '../../useEventListFilters';
import st from '../popovers.module.sass';

function EmotionsFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { filters, updateFilters } = useEventListFilters();

  const selectedEmotions = filters.emotions ?? [];

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={selectedEmotions.length === 0}
      onClickReset={() => updateFilters({ emotions: undefined })}
      ref={ref}
    >
      <OptionsFilter
        isSearchable={false}
        onChange={(value) => updateFilters({
          emotions: value.length > 0 ? (value as unknown as EmotionsNullableParameter) : undefined,
        })}
        options={EMOTION_OPTIONS.raw}
        value={selectedEmotions as unknown as string[]}
      />
      <div className={st.Divider} />
    </PopoverWithButton>
  );
}

const EmotionsFilterPopoverWithRef = forwardRef(EmotionsFilterPopover);
export { EmotionsFilterPopoverWithRef as EmotionsFilterPopover };
